// extracted by mini-css-extract-plugin
export var latest = "latest-module--latest--1VUSt";
export var latest__news = "latest-module--latest__news--Dfys1";
export var latest__news__item = "latest-module--latest__news__item--11nlg";
export var latest__news__item__bg = "latest-module--latest__news__item__bg--1PU5L";